import React, { useCallback, useEffect, useState } from 'react'
import Layout from '../components/common/Layouts/Layout'
import GenericTable from '../components/custom/GenericTable'
import { options } from '../data/data'
import useColumns from '../components/hooks/useColumns'
import { useDispatch, useSelector } from 'react-redux'
import { deleteRecommendation, getRecommendationListData } from '../redux/actions/recommendation.action'
import Button from '../components/common/Button/Button'
import AddRecommendation from '../components/common/Modal/AddRecommendation'
import DeleteRecommmendation from '../components/common/Modal/DeleteRecommmendation'
import { debounce } from 'lodash'
import { SearchDataChange } from '../components/hooks/SearchDataContext'
import RecommendationDetail from '../components/common/Modal/RecommendationDetail'
import { imageUrl } from '../config/url'
import { ATTCHED_ICON, MONEYS_ICON } from '../config/images'
import { IoEyeOutline } from 'react-icons/io5'
import Select from "react-select";
import { Pagination, PaginationContent, PaginationItem, PaginationLink, PaginationNext, PaginationPrevious } from '../components/custom/pagination'


const Recommendation = () => {
    const { searchQuery } = SearchDataChange();
    const dispatch = useDispatch();
    const { loading, recommendation_list, total_recommendation } = useSelector((state) => state.recommendation);
    const [search, setSearch] = useState("");
    const [limitVal, setLimitVal] = useState(options[1]);
    const [limit, setLimit] = useState(10);
    const [currentPage, setCurrentPage] = useState(1);
    const [pageArray, setPageArray] = useState([]);
    const [modalOpen, setModalOpen] = useState({
        open: false,
        data: null,
        mode: null
    })
    const [deleteOpen, setDeleteOpen] = useState({
        open: false,
        data: null
    })
    const [detailModal, setDetailModal] = useState({
        open: false,
        data: null
    })

    const handleEdit = (props) => {
        setModalOpen({
            open: true,
            data: props,
            mode: "edit"
        })
    }

    const handleDelete = (props) => {
        setDeleteOpen({
            open: true,
            data: props
        })
    }

    const handleView = (props) => {
        setDetailModal({
            open: true,
            data: props
        })
    }

    const handleConfirmDelete = () => {

        dispatch(deleteRecommendation({ _id: deleteOpen?.data?._id })).unwrap().then(() => {
            setDeleteOpen({
                open: false,
                data: null
            })
            dispatch(getRecommendationListData({ page: currentPage, limit: limit, search: search }))
        })
    }

    const debouncedSearch = useCallback(
        debounce((query) => {
            setSearch(query);
        }, 500),
        []
    );


    useEffect(() => {
        setCurrentPage(1);
    }, [limit, search]);
    useEffect(() => {
        let pages = total_recommendation == 0 ? 0 : Math.ceil(total_recommendation / limit);
        setPageArray(Array.from({ length: pages }));
    }, [total_recommendation, limit]);

    useEffect(() => {
        setLimit(limitVal.value);
    }, [limitVal]);

    useEffect(() => {
        debouncedSearch(searchQuery);
    }, [searchQuery]);




    useEffect(() => {
        dispatch(getRecommendationListData({ page: currentPage, limit: limit, search: search }));
    }, [currentPage, limit, search]);



    // useEffect(() => {
    //     dispatch(getRecommendationListData({ page: 1, limit: 10 }));
    // }, [])

    const { recommendation } = useColumns({ handleEdit, handleDelete, handleView });
    return (
        <Layout title="Recommendation">
            <div className='flex flex-col gap-5'>
                <div className='flex justify-end'>
                    <Button
                        className={`py-2 rounded-[10px] bg-[#383F90] font-medium text-lg w-[120px] `}
                        text="Create"
                        type={true}
                        onClick={() => {
                            setModalOpen({
                                open: true,
                                data: null,
                                mode: "add"
                            })
                        }}
                    />
                </div>
                <div className='grid grid-cols-1 md:grid-cols-3 gap-5'>
                    {
                        recommendation_list?.map((item, index) => {
                            return (
                                <div className='bg-white  p-4 rounded-[16px]'>
                                    <div className='flex justify-between items-center'>
                                        <img src={item?.recommendation_img} alt="recommendation_img" className='w-[66px] h-[66px] rounded-[8px] object-cover border border-[#E0E0E0]' />
                                        <div className='flex gap-3 items-center'>
                                            <img src={`${imageUrl}icons/Edit.svg`} alt="" className="cursor-pointer" onClick={() => handleEdit(item)} />
                                            <img src={`${imageUrl}icons/Delete.svg`} alt="" className="cursor-pointer" onClick={() => handleDelete(item)} />
                                            <IoEyeOutline className="cursor-pointer text-[#2D264B] size-7 font-semibold" onClick={() => handleView(item)} />
                                        </div>
                                    </div>
                                    <div className='mt-5 text-start space-y-3'>
                                        <p className='text-[#0F172A] sm:text-[22px] text-base font-semibold'>{item?.name}</p>
                                        <div className='flex gap-2 items-center'>
                                            <img src={ATTCHED_ICON} alt="attached_icon" className=' cursor-pointer' />
                                            <p className='text-[#0F172A] text-sm font-normal line-clamp-2'>{item?.link}</p>
                                        </div>
                                        <div className='flex gap-2 items-center'>
                                            <img src={MONEYS_ICON} alt="moneys_icon" className='cursor-pointer' />
                                            <p className='text-[#0F172A] text-sm font-normal line-clamp-1'>{item?.offer}</p>
                                        </div>
                                        <div className='flex gap-2 items-center'>
                                            <img src={MONEYS_ICON} alt="moneys_icon" className=' cursor-pointer' />
                                            <p className='text-[#0F172A] text-sm font-normal line-clamp-1'>{item?.description}</p>
                                        </div>
                                        {/* <p className='text-[#0F172A] text-sm font-normal line-clamp-2'>{item?.description}</p> */}
                                    </div>
                                </div>
                            )
                        })
                    }

                </div>
                <div className="px-6 py-2 flex justify-between items-center gap-y-2 sm:gap-y-0 flex-col sm:flex-row bg-white">
                    {recommendation_list.length > 0 ? (
                        <p className="w-full text-center sm:text-start text-ternary text-[13px] sm:text-[15px] font-semibold">
                            {" "}
                            Showing {(currentPage - 1) * limit + 1}-
                            {(currentPage - 1) * limit + recommendation_list.length} on page {currentPage}/
                            {pageArray.length}
                        </p>
                    ) : (
                        <p></p>
                    )}
                    <div className="flex items-center gap-x-4">
                        <div>
                            <Select
                                value={limitVal}
                                isSearchable={false}
                                onChange={(e) => {
                                    setLimitVal(e);
                                }}
                                className="w-[80px] focus:outline-none focus:border-none"
                                placeholder=""
                                options={options}
                                menuPlacement="top"
                            />
                        </div>
                        <div>
                            <Pagination className="justify-center sm:justify-end">
                                <PaginationContent>
                                    <PaginationItem>
                                        <PaginationPrevious
                                            className=""
                                            iconStyle="stroke-[#667BA3] stroke-[2.5px] group-hover:stroke-[#F7FCF9]"
                                            onClick={() => {
                                                if (!(currentPage == 1)) {
                                                    setCurrentPage((prev) => prev - 1);
                                                }
                                            }}
                                        />
                                    </PaginationItem>
                                    {pageArray.map((_, index) => {
                                        return (
                                            <PaginationItem key={index}>
                                                <PaginationLink
                                                    onClick={() => setCurrentPage(index + 1)}
                                                    isActive={currentPage == index + 1}
                                                    className=""
                                                >
                                                    {index + 1}
                                                </PaginationLink>
                                            </PaginationItem>
                                        );
                                    })}
                                    <PaginationItem>
                                        <PaginationNext
                                            className=""
                                            iconStyle="stroke-[#667BA3] stroke-[2.5px] group-hover:stroke-[#F7FCF9]"
                                            onClick={() => {
                                                if (!(currentPage == pageArray.length)) {
                                                    setCurrentPage((prev) => prev + 1);
                                                }
                                            }}
                                        />
                                    </PaginationItem>
                                </PaginationContent>
                            </Pagination>
                        </div>
                    </div>
                </div>
                {/* <div className='w-full'>
                    <GenericTable limitVal={limitVal}
                        setLimitVal={setLimitVal} columns={recommendation}
                        total={total_recommendation}
                        getData={getRecommendationListData}
                        loading={loading}
                        search={search}
                        iseUserId={false}
                        data={recommendation_list} height="h-[70vh]"
                        message=" Orders Not Found" />
                </div> */}
            </div>
            {
                modalOpen?.open && <AddRecommendation data={modalOpen} setData={setModalOpen} />
            }
            {
                deleteOpen?.open && <DeleteRecommmendation data={deleteOpen} setData={setDeleteOpen} handleDelete={handleConfirmDelete} />
            }
            {
                detailModal?.open && <RecommendationDetail data={detailModal} setData={setDetailModal} />
            }
        </Layout>
    )
}

export default Recommendation